'use client'

import { Avatar, AvatarFallback, AvatarImage } from 'ui/avatar'
import CarouselSection from 'layout/Carousel/CarouselSection'
import Link from 'components/shared/link'
import { CarouselItem } from 'components/ui/carousel'
import { useState } from 'react'
import { useEffect } from 'react'
import WidgetWrapper from 'components/WidgetWrapper'

interface LandingOrganisationsProps {
    landingOrganisationTexts: {
        organisations: string
        onOur: string
        platform: string
    }
    organisations: ICarouselItem[]
}

const LandingOrganisations = ({ landingOrganisationTexts, organisations }: LandingOrganisationsProps) => {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    if (!mounted) {
        // Optionally render a placeholder or null to ensure server and initial client render match
        return null
    }
    return (
        <WidgetWrapper>
            <CarouselSection
                title={`${landingOrganisationTexts.onOur} ${landingOrganisationTexts.platform}`}
                titleHighlight={landingOrganisationTexts.organisations}
            >
                {organisations.map(org => (
                    <CarouselItem key={org.id} className='pl-3 basis-1/1'>
                        <Link href={`/organisation/${org.id}`}>
                            <Avatar className='w-[120px] h-[120px] rounded-full border-2 border-[#436dca]'>
                                <AvatarImage src={org.logo} alt={org.name} />
                                <AvatarFallback>{org.name.charAt(0).toUpperCase()}</AvatarFallback>
                            </Avatar>
                        </Link>
                    </CarouselItem>
                ))}
            </CarouselSection>
        </WidgetWrapper>
    )
}

export default LandingOrganisations
